export default __webpack_public_path__ + "static/gradient-15d90fb6d8fa0c5b1a6c7356603eef2a.webp";